import React from "react";

type RadioType = {
  children: string;
  selected: boolean | null;
  name: string;
  customValues?: string[];
  required?: boolean;
  onSelect: (state: boolean) => void;
};

const CustomRadio = ({
  children,
  selected,
  name,
  customValues,
  required,
  onSelect,
}: RadioType) => {
  return (
    <div className="mb-4">
      <div className="mb-2">
        {children} {required ? "*" : ""}
      </div>
      <Radio
        selected={selected === true ? true : false}
        onSelect={() => onSelect(true)}
        name={name}
      >
        {customValues ? customValues[0] : "Yes"}
      </Radio>
      <Radio
        selected={selected === false ? true : false}
        onSelect={() => onSelect(false)}
        name={name}
      >
        {customValues ? customValues[1] : "No"}
      </Radio>
    </div>
  );
};

type PlainRadioType = {
  children: string;
  selected: boolean;
  name: string;
  onSelect: () => void;
};

const Radio = ({ children, selected, name, onSelect }: PlainRadioType) => {
  return (
    <div className="form-control w-fit">
      <label className="label cursor-pointer p-1">
        <input
          type="radio"
          name={name}
          className="radio checked:bg-primary mr-4"
          checked={selected}
          onChange={() => onSelect()}
        />
        <span className="label-text">{children}</span>
      </label>
    </div>
  );
};

export default CustomRadio;
